import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';

const SPOTIFY_ARTIST_URL = "https://open.spotify.com/artist/2GGq3e18M0FOrBKMwtLLl7";

const ANTHEM_COVER = "https://customer-assets.emergentagent.com/job_14cc4871-687e-4891-af0a-b689414d4eb3/artifacts/acyyeaud_Welcome%20to%20YOU%20The%20Alchemy%20Village%20song.png";

const anthemTrack = {
  id: 'anthem',
  title: "Welcome to YOU",
  src: "/village-anthem.mp3",
  featured: true,
};

const featuredTrack = {
  id: 0,
  title: "Choose What Matters",
  src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/clb4eh3z_%F0%9F%8E%B6%20CHOOSE%20WHAT%20MATTERS.wav",
  featured: true,
};

const spotifyReleases = [
  {
    id: 'fafo',
    title: 'F.A.F.O.',
    type: 'Album',
    embedUrl: 'https://open.spotify.com/embed/album/0zbBymB2LywzQmgEluXuIQ?theme=0&utm_source=generator',
  },
  {
    id: 'didnt-know',
    title: "I Didn't Know I was READY...",
    type: 'Single',
    embedUrl: 'https://open.spotify.com/embed/album/6R5MFhAKw5EQ5Oa516CG9p?theme=0&utm_source=generator',
  },
  {
    id: 'cleansing',
    title: 'Cleansing',
    type: 'Single',
    embedUrl: 'https://open.spotify.com/embed/track/2lhpfSXNBTZRjDRowqjwDV?theme=0&utm_source=generator',
  },
];

const alchemistTracks = [
  { id: 1, title: "I said F.U.C.K. T.H.A.T.T., Took My Life", src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/p695xja1_I%20said%20F.U.C.K.%20T.H.A.T.T.%2C%20took%20my%20life%20copy.mp3" },
  { id: 2, title: "F.U.C.K. T.H.A.T.T. I've Made Up My Mind", src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/0bt9oxrc_F.U.C.K.%20T.H.A.T.T.%20I%27ve%20made%20up%20my%20Mind.mp3" },
  { id: 3, title: "F.U.C.K. T.H.A.T.T. I'm Choosing What I WANT", src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/2d3xd1p7_F.U.C.K.%20T.H.A.T.T.%20I%27m%20choosing%20what%20I%20WANT.mp3" },
  { id: 4, title: "F.U.C.K. T.H.A.T.T. Why Do I Want It?", src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/jllwearz_F.U.C.K.%20T.H.A.T.T.%20Why%20do%20I%20want%20it_%20.mp3" },
  { id: 5, title: "F.U.C.K. T.H.A.T.T. It Feeds My SOUL", src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/kixsynji_F.U.C.K.%20T.H.A.T.T.%20it%20feeds%20my%20SOUL%20%281%29.mp3" },
  { id: 6, title: "F.U.C.K. T.H.A.T.T. Let's Get You FED", src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/bplweo3o_Fuck%20Thatt%20Let%27s%20get%20you%20FED%20%20%282%29.mp3" },
  { id: 7, title: "F.U.C.K. T.H.A.T.T. I'm FREE!", src: "https://customer-assets.emergentagent.com/job_3344cd9f-1cb7-499b-8f13-a3a84e1239be/artifacts/7uyuy9vs_F.U.C.K.%20T.H.A.T.T.%20I%27m%20FREE%21.mp3" },
];

function formatTime(s) {
  if (!s || isNaN(s)) return '0:00';
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, '0')}`;
}

function TrackPlayer({ track, isActive, onPlay, featured }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    if (!isActive && playing) {
      audioRef.current?.pause();
      setPlaying(false);
    }
  }, [isActive]);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      onPlay();
      audio.play();
      setPlaying(true);
    }
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    if (!audio) return;
    setCurrentTime(audio.currentTime);
    setProgress(audio.duration ? (audio.currentTime / audio.duration) * 100 : 0);
  };

  const handleSeek = (e) => {
    const audio = audioRef.current;
    if (!audio || !audio.duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const pct = (e.clientX - rect.left) / rect.width;
    audio.currentTime = pct * audio.duration;
  };

  const handleEnded = () => { setPlaying(false); setProgress(0); };

  return (
    <div className={`track-player ${isActive && playing ? 'track-player--active' : ''} ${featured ? 'track-player--featured' : ''}`} data-testid={`track-${track.id}`}>
      <audio
        ref={audioRef}
        src={track.src}
        preload="metadata"
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={() => setDuration(audioRef.current?.duration || 0)}
        onEnded={handleEnded}
      />
      <button className="track-play-btn" onClick={toggle} data-testid={`play-${track.id}`}>
        {playing ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        )}
      </button>
      <div className="track-info">
        <span className="track-name">{track.title}</span>
        <div className="track-progress-row">
          <div className="track-bar" onClick={handleSeek}>
            <div className="track-bar-fill" style={{ width: `${progress}%` }} />
          </div>
          <span className="track-time">{formatTime(currentTime)} / {formatTime(duration)}</span>
        </div>
      </div>
    </div>
  );
}

export default function MusicPage() {
  const [activeTrack, setActiveTrack] = useState(null);

  return (
    <section data-testid="music-page" className="music-page">
      <div className="music-hero">
        <p className="music-label">Nonae' Michelle presents</p>
        <h1 className="music-title" data-testid="music-title">Alchemist Music</h1>
        <p className="music-subtitle">The sound of transformation.</p>
      </div>

      <div className="music-content">
        {/* The Village Anthem — Welcome to YOU */}
        <div className="music-featured music-featured--anthem" data-testid="village-anthem">
          <span className="music-featured-label">The Village Anthem</span>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.75rem', alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}>
            <img
              src={ANTHEM_COVER}
              alt="Welcome to YOU — The Alchemy Village"
              data-testid="anthem-cover"
              loading="lazy"
              style={{ width: '230px', maxWidth: '70vw', borderRadius: '16px', boxShadow: '0 18px 48px rgba(0,0,0,0.55)', border: '1px solid rgba(212,175,55,0.4)' }}
            />
            <div style={{ flex: '1 1 320px', minWidth: '280px', textAlign: 'left' }}>
              <h2 className="music-featured-title" style={{ marginBottom: '0.25rem' }}>Welcome to YOU</h2>
              <p className="music-featured-artist">The Alchemy Village · Theme Song</p>
              <div className="music-featured-player">
                <TrackPlayer
                  track={anthemTrack}
                  isActive={activeTrack === anthemTrack.id}
                  onPlay={() => setActiveTrack(anthemTrack.id)}
                  featured
                />
              </div>
              <a
                href="/village-anthem.mp3"
                download="The Village Anthem - Welcome to YOU.mp3"
                className="village-btn village-btn--secondary"
                data-testid="anthem-download-btn"
                style={{ marginTop: '1rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
              >
                <Download size={16} /> Download the Anthem
              </a>
            </div>
          </div>
        </div>

        {/* Featured Single */}
        <div className="music-featured" data-testid="featured-track">
          <span className="music-featured-label">Featured Single</span>
          <h2 className="music-featured-title">Choose What Matters</h2>
          <p className="music-featured-artist">Nonae' Michelle</p>
          <div className="music-featured-player">
            <TrackPlayer
              track={featuredTrack}
              isActive={activeTrack === featuredTrack.id}
              onPlay={() => setActiveTrack(featuredTrack.id)}
              featured
            />
          </div>
        </div>

        {/* Original Tracks */}
        <div className="music-section" data-testid="original-tracks">
          <h2 className="music-section-title">The F.U.C.K. T.H.A.T.T. Collection</h2>
          <p className="music-section-desc">7 tracks. One declaration of freedom.</p>
          <div className="track-list">
            {alchemistTracks.map((track) => (
              <TrackPlayer
                key={track.id}
                track={track}
                isActive={activeTrack === track.id}
                onPlay={() => setActiveTrack(track.id)}
              />
            ))}
          </div>
        </div>

        {/* Spotify Releases */}
        <div className="music-section" data-testid="spotify-releases">
          <h2 className="music-section-title">On Spotify</h2>
          <div className="music-releases">
            {spotifyReleases.map((release) => (
              <div key={release.id} className="music-release-card" data-testid={`release-${release.id}`}>
                <span className="music-release-type">{release.type}</span>
                <h3 className="music-release-title">{release.title}</h3>
                <div className="music-embed">
                  <iframe
                    src={release.embedUrl}
                    width="100%"
                    height={release.type === 'Album' ? 352 : 152}
                    frameBorder="0"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    title={release.title}
                    style={{ borderRadius: '12px' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Gangsta AI CTA removed — page temporarily down */}

        <div className="music-cta">
          <a
            href={SPOTIFY_ARTIST_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="village-btn village-btn--primary"
            data-testid="spotify-follow-btn"
          >
            Follow on Spotify
          </a>
          <Link to="/life-map" className="village-btn village-btn--secondary">
            Back to Life-Map
          </Link>
        </div>
      </div>
    </section>
  );
}
